import { IntlShape } from "react-intl";

export const getMainFilterIndustrySpecialistOptions = (intl: IntlShape) => [
  { value: "name", label: intl.formatMessage({ id: "usAdmin.name" }) },
  { value: "email", label: intl.formatMessage({ id: "usAdmin.email" }) },
];

export const INDUSTRY_SPECIALIST_TABLE = {
  MOBILE_ROWS: 10,
  MOBILE_COLUMNS: 1,
  DESKTOP_ROWS: 10,
  DESKTOP_COLUMNS: 2,
};

export const INDUSTRY_SPECIALIST_KEYS = {
  NAME: "name",
  EMAIL: "email",
};
